// [uTheory](http://utheory.com) - Copyright (c) Gregory Ristow 2018
//
// ## Blank for Interactive Game
//
// Include description of object & useful info here, please!
import type { BaseDuration, RhythmicDuration } from 'shared/definitions/musicTheory/rhythms';
import type { InteractiveOptions, InteractiveSettings, LayoutSettings, UserData } from '../interactivePrototype';
import InteractivePrototype from '../interactivePrototype';
import type { AnswerAndData } from '../interactiveQuestionPrototype';
import NameTheRhythmUi from './NameTheRhythmUI.svelte';

type Dots = '' | '.';
type RestString = '' | 'r';
export type NameTheRhythmQuestion = `${BaseDuration}${Dots}${RestString}`;

export interface NameTheRhythmOptions extends InteractiveOptions {
  rhythmicValues: NameTheRhythmQuestion[],
  drill: false,
  testMode: true
}

export class NameTheRhythm extends InteractivePrototype {
  layout: LayoutSettings = {
    instructions: {
      maxPercent: 100
    }
  }

  settings: InteractiveSettings = {
    instructions: true,
  }

  declare options: NameTheRhythmOptions;

  currentQuestion: NameTheRhythmQuestion | null = null;

  questions: NameTheRhythmQuestion[] = [];

  constructor(displayDiv: HTMLDivElement, options: NameTheRhythmOptions, userData?: UserData) {
    super(displayDiv, options, userData);

    if(options.drill || !options.testMode) {
      throw Error('NameTheRhythm only works in test mode.');
    }

    this.init();
  }

  nameTheRhythmUI!: NameTheRhythmUi;

  svelteDiv!: HTMLDivElement;

  createCustomDivs() {
    this.svelteDiv = document.createElement('div');
    this.svelteDiv.classList.add('svelte-div');
    this.displayDiv.append(this.svelteDiv);

    this.layout.svelteDiv = {
      div: this.svelteDiv,
      name: 'svelteDiv',
      percent: 100,
      visible: true,
    };
  }

  init() {
    return super.init(this.displayDiv, this.options).then(() => {
      console.log({ svelteDiv: this.svelteDiv})
      this.nameTheRhythmUI = new NameTheRhythmUi({
        target: this.svelteDiv,
        props: {
          rhythmicValues: this.options.rhythmicValues
        },
      });

      this.nameTheRhythmUI.$on('ANSWER_ATTEMPT', (e: CustomEvent<AnswerAndData>) => {
        this.checkpointAnswerCallbacks.forEach((cb) => cb(e.detail));
      })
    })
  }

  resize() { return Promise.resolve()}

  generateQuestions(questions?: NameTheRhythmQuestion[]) {
    if (!questions) {
      this.questions = [];
      return;
    }
    this.questions = questions;
  }

  // ## CheckPoint Mode Questions:
  newCheckpointQuestion(questionString: NameTheRhythmQuestion) {
    console.log('new cp question')
    return this.loadingPromise.then(() => {
      console.log('post loading promise...')
      this.questions = [questionString];
      this.currentQuestion = questionString;
      console.log('setting the question...')
      this.nameTheRhythmUI.$set({ question: questionString });
      this.questionNumber = 0;
      return Promise.resolve(this.newQuestion());
    });
  }

  // For checkpoint tests, the answer & data from the current question is
  // logged via a callback.
  getAnswerAndData(): AnswerAndData {
    return this.nameTheRhythmUI.getAnswerAndData();
  }
}

